export default "__VITE_ASSET__CNKnJVQL__"